import { Box } from "components";
import styled from "styled-components";

const Skills = () => (
  <Styled>
    <Box aside title="Skills" type="skills">
      <div>
        <p className="intro">These are my top skills ❤️</p>
        <div className="skillset">
          <div className="item">
            <h3 className="level-title">
              React &amp; Redux
              <span
                className="level-label"
                data-toggle="tooltip"
                data-placement="left"
                data-animation="true"
                title="I love React <3 "
              >
                Expert
              </span>
            </h3>
            <div className="level-bar">
              <div className="level-bar-inner" data-level="96%"></div>
            </div>
          </div>
          <div className="item">
            <h3 className="level-title">
              React Native
              <span
                className="level-label"
                data-toggle="tooltip"
                data-placement="left"
                data-animation="true"
                title="I love React Native <3 "
              >
                Expert
              </span>
            </h3>
            <div className="level-bar">
              <div className="level-bar-inner" data-level="96%"></div>
            </div>
          </div>
          <div className="item">
            <h3 className="level-title">
              Typescript<span className="level-label">Expert</span>
            </h3>
            <div className="level-bar">
              <div className="level-bar-inner" data-level="96%"></div>
            </div>
          </div>
          <div className="item">
            <h3 className="level-title">
              Vue.js<span className="level-label">Expert</span>
            </h3>
            <div className="level-bar">
              <div className="level-bar-inner" data-level="96%"></div>
            </div>
          </div>
          <div className="item">
            <h3 className="level-title">
              Node.js (Express, NestJS)
              <span className="level-label">Expert</span>
            </h3>
            <div className="level-bar">
              <div className="level-bar-inner" data-level="96%"></div>
            </div>
          </div>
          <div className="item">
            <h3 className="level-title">
              Android (Java, Kotlin){" "}
              <span className="level-label">Advanced</span>
            </h3>
            <div className="level-bar">
              <div className="level-bar-inner" data-level="80%"></div>
            </div>
          </div>
          <a
            className="more-link"
            href="https://www.linkedin.com/in/onurdmrts"
            target="_blank"
            rel="noreferrer"
            aria-label="Visit my LinkedIn profile"
          >
            <i className="fa fa-linkedin-square linkedin" /> More on Linkedin
          </a>
        </div>
      </div>
    </Box>
  </Styled>
);

const Styled = styled.div`
  .more-link {
    display: flex;
    align-items: center;
    width: fit-content;

    .linkedin {
      font-size: 20px !important;
    }
  }
`;

export default Skills;
